export class StanleyQueryCreditsExpiredError extends Error {
  readonly status = 402;

  constructor(message = 'Credits expired') {
    super(message);
    this.name = 'StanleyQueryCreditsExpiredError';
  }
}

export const isStanleyQueryCreditsExpiredError = (
  error: unknown
): error is StanleyQueryCreditsExpiredError =>
  error instanceof StanleyQueryCreditsExpiredError ||
  (typeof error === 'object' &&
    error != null &&
    'status' in error &&
    (error as { status?: number }).status === 402);
